import { ReactNode } from 'react';

export const ProfileSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <div className="my-4">
      <h3 className="mb-3 text-xl font-semibold">{title}</h3>
      {children}
    </div>
  );
};
